import AddIcon from '@mui/icons-material/Add';
import DeleteButton from '../components/DeleteButton';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Grid, IconButton, InputAdornment, TextField, Toolbar, Tooltip } from '@mui/material';
import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { CREATE, DataAPIContext } from '../api';
import { ContextStore } from '../store/contextStore';
import { debounce } from '../utils';

const ActivityListToolbar = (props) => {
    const createBt = React.useRef(null);
    const deleteBt = React.useRef(null);
    const searchQueryRef = React.useRef(null);
    const dataAPI = React.useContext(DataAPIContext);
    const history = useHistory();
    const { hasPerm, isFranchise, currentLicensee } = React.useContext(ContextStore);
    const btSize = props.isSmallScreen ? 'medium' : 'small';
    const createDisabled = isFranchise && !currentLicensee;

    const onCreateNewActivityBtClick = (ev) => {
        (async () => {
            try {
                const res = await dataAPI(CREATE, props.resource, { data: {} });
                const id = +res.data.id;
                if (id > 0) {
                    history.push(`/activity/${id}`);
                }
            } catch (e) {
                console.error(e);
            }
        })();
    };
    const handleSearchQueryChange = (ev) => {
        debouncedSearchQueryChangeHandler.cancel();
        doSearch(searchQueryRef.current?.value);
    };

    const onDeleteActivityBtClick = (ev) => {
        props.onDeleteActivity && props.onDeleteActivity(props.selectedIds);
    };

    const debouncedSearchQueryChangeHandler = debounce(handleSearchQueryChange, 300);

    const doSearch = (query) => props.onQueryChange && props.onQueryChange(query);

    return (
        <Toolbar disableGutters={true} sx={{ minHeight: 0 }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item xs={12} sm={4} container spacing={2} alignItems={'center'} wrap="nowrap">
                    <Grid item xs sm={12}>
                        <TextField
                            variant="filled"
                            label="Search"
                            size="small"
                            onChange={debouncedSearchQueryChangeHandler}
                            inputRef={searchQueryRef}
                            defaultValue={props.query}
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip title="Search">
                                            <IconButton aria-label="do search" onClick={handleSearchQueryChange}>
                                                <SearchIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    {props.isSmallScreen && (hasPerm('activity', 'write') || props.onDocumentExport) && (
                        <Grid item xs="auto" container justifyContent={'flex-end'} wrap="nowrap" gap={1}>
                            {hasPerm('activity', 'write') && (
                                <Tooltip title={createDisabled ? 'Please select a licensee' : 'New activity'}>
                                    <span>
                                        <Button ref={createBt} onClick={onCreateNewActivityBtClick} variant="contained" color="primary" disabled={createDisabled}>
                                            <AddIcon />
                                        </Button>
                                    </span>
                                </Tooltip>
                            )}
                            {props.onDocumentExport && (
                                <Tooltip title="Export">
                                    <Button variant="outlined" color="primary" onClick={props.onDocumentExport} sx={{ minWidth: 0 }}>
                                        <FileUploadOutlinedIcon />
                                    </Button>
                                </Tooltip>
                            )}
                        </Grid>
                    )}
                </Grid>
                <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                    {props.selectedIds?.length > 0 && !props.isSmallScreen ? (
                        <Box mr={2}>
                            <DeleteButton ref={deleteBt} perm="activity.delete" size={btSize} onClick={onDeleteActivityBtClick}>
                                Delete {props.selectedIds.length > 1 ? 'activities' : 'activity'}
                            </DeleteButton>
                        </Box>
                    ) : null}
                    {!hasPerm('activity', 'write') || props.isSmallScreen || props.selectedIds?.length > 0 ? null : (
                        <Box direction="row-reverse">
                            <Tooltip title={createDisabled ? 'Please select a licensee' : ''}>
                                <span>
                                    <Button ref={createBt} color="primary" variant="contained" size={btSize} onClick={onCreateNewActivityBtClick} disabled={createDisabled}>
                                        <AddIcon />
                                        &nbsp;{!props.isSmallScreen ? 'New activity' : null}
                                    </Button>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                    {/* After [+], like every other list header (CP-8291). */}
                    {props.onDocumentExport && !props.isSmallScreen ? (
                        <Box ml={1} component="span">
                            <Button variant="outlined" color="primary" size={btSize} onClick={props.onDocumentExport}>
                                <FileUploadOutlinedIcon />
                                &nbsp;{props.selectedIds?.length > 0
                                    ? `Export (${props.selectedIds.length} selected)`
                                    : 'Export'}
                            </Button>
                        </Box>
                    ) : null}
                </Grid>
            </Grid>
        </Toolbar>
    );
};

export default ActivityListToolbar;
